module.exports = {"371325001":"费城街道","371325101":"上冶镇","371325102":"薛庄镇","371325105":"探沂镇","371325106":"朱田镇","371325107":"梁邱镇","371325108":"新庄镇","371325109":"马庄镇","371325112":"胡阳镇","371325113":"石井镇","371325200":"大田庄乡","371325201":"南张庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371325.json
// module id = 1348
// module chunks = 0